import { EthereumStakingValidatorInfo } from '#/data/react-query/queries/order-list';
import React from 'react';
import { Hex } from 'viem';
import { InterpreterFrom, assign, createMachine } from 'xstate';

interface MachineContext {
  originalRow: EthereumStakingValidatorInfo;
  amount: bigint | null;
  transactionHash: Hex | null;
}
const machine = createMachine<MachineContext>({
  predictableActionArguments: true,
  preserveActionOrder: true,
  context: {
    originalRow: null as any as EthereumStakingValidatorInfo,
    amount: null,
    transactionHash: null,
  },
  initial: 'information',
  states: {
    information: {
      on: {
        NEXT: {
          target: 'transaction',
          actions: assign((context, event) => {
            const { amount } = event.data;
            return { amount };
          }),
        },
      },
    },
    transaction: {
      tags: 'loading',
      invoke: {
        src: 'onTransaction',
        onDone: {
          target: 'transactionReceipt',
          actions: assign((context, event) => {
            const { transactionHash } = event.data;
            return { transactionHash };
          }),
        },
        onError: 'information',
      },
    },
    transactionReceipt: {
      tags: 'completed',
    },
  },
});

const MachineContext = React.createContext(
  {} as InterpreterFrom<typeof machine>
);

export { MachineContext };

export default machine;
